module.exports = {
  flavour: require('./flavour')
}
